import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-pill-status',
  templateUrl: './pill-status.component.html',
  styleUrls: ['./pill-status.component.scss']
})
export class PillStatusComponent {
  
  @Input() status: string | number;

  // pill colors
  colors = {
    1: 'warning',
    2: 'info',
    3: 'success',
    4: 'danger'
  };

}
